<template>
  <img
    :src="imageUrl"
    alt=""
    class="rounded-full"
    :class="[
      size === 'small' ? 'h-6 w-6' : '',
      size === 'medium' ? 'h-8 w-8' : '',
      size === 'standard' ? 'h-10 w-10' : '',
      size === 'large' ? 'h-12 w-12' : '',
      size === 'xl' ? 'h-16 w-16' : ''
    ]"
  />
</template>

<script lang="ts" setup>
import md5 from 'md5';
import { computed } from 'vue';

interface Props {
  size?: 'small' | 'medium' | 'standard' | 'large' | 'xl';
  avatar?: string;
  email?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'standard',
  avatar: '',
  email: ''
});

const imageUrl = computed(() => {
  if (props.avatar) {
    return props.avatar;
  }

  const hash = md5((props.email || '').trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?d=mp`;
});
</script>
